// src/components/Layout.js
import React from "react";
import { Link } from "gatsby";
import Navigation from "./NavMain";
import Footer from "./FooterMain";
import CrispChat from "./CrispChat";
import Banner01 from "./Banner01";

const Layout = ({ children }) => {
  return (
    <div className="flex flex-col min-h-screen">
      <div className="fixed top-0 left-0 right-0 z-50">
        {/* <Banner01 /> */}
        <Navigation />
      </div>
      <main className="flex-grow mt-[10px] md:mt-[10px]">
        {children}
      </main>
      <CrispChat />
      <Footer />
    </div>
  );
};

export default Layout;